<style scoped>
  .search >>> .ivu-input {width: 348px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
  .approval >>> .ivu-btn {width: 130px;border-radius: 36px;}
  .approval-list-tab {text-align: center;color: #333333;font-size: 14px;font-weight: bold;line-height: 62px; /*border-bottom: 1px solid #d7dde4;*/}
  .approval-list {text-align: center;color: #464c5b;font-size: 14px;height: 95px;/*border-bottom: 1px solid #d7dde4;*/}
  .notice-background{background: url("/img/sys/bg6.png");height: 140px;}
  .jurisdiction{font-size: 14px;color: #464c5b;line-height: 60px;height: 60px;font-weight: bold;text-align: center;border-bottom: 1px solid #d7dde4;}
  .jurisdiction-list{font-size: 14px;color: #464c5b;line-height: 76px;height: 76px;text-align: center;border-bottom: 1px solid #d7dde4;}
  .tips-middle{display: inline-block;vertical-align:middle;line-height: 1em}
</style>

<template>
  <div>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <div style="background-color: #fff;padding:0 40px;">
    <Row style="background-color: white;height: 114px;position: relative;">
      <Col span="20" style="position: absolute;top: 50%;left: 0;transform: translate(0, -50%);">
        <div style="position: relative;">
          <Input class="search" v-model="search.text" placeholder="搜索项目名称/客户名称/主体名称"></Input>
          <div
              @click="search.page=1,getList(),getContactsList(),getUserList()"
              style="background-color: #00a2e9;width: 28px;height: 28px;border-radius: 14px;position: absolute;top: 4px;text-align: center;left: 310px;cursor:pointer;">
            <img style="margin-top: 6px;" src="/img/project/search-icon.png"/>
          </div>
        </div>
      </Col>
      <Col span="3" class="approval" style="position: absolute;z-index:1;top: 50%;right: 20px;transform: translate(0, -50%);" v-if="$store.state.userInfo.groupName=='超级管理员'">
        <Dropdown style="margin-left: 20px" trigger="click">
          <Button type="primary" style="width:80px">
            新增
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem>
              <div @click="edit = {panel:true,name:'',id:'', mobile:'',IDCardCode:'',role:'',state:'1',}">客户名录</div>
            </DropdownItem>
            <DropdownItem>
              <div @click="contactsEdit={panel:true,name:'',tel:'',id:''}">司法通讯录</div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Col>
    </Row>
    <!---->
    <Tabs value="customer">
      <TabPane label="客户名录" name="customer">
        <Row class="approval-list-tab">
          <Col span="3">姓名</Col>
          <Col span="2">性质</Col>
          <Col span="2">联系人</Col>
          <Col span="2">联系电话</Col>
          <Col span="4">身份证号</Col>
          <Col span="2">
            客户角色
            <!--<Dropdown trigger="click">-->
            <!--<div style="cursor:pointer;">-->
            <!--客户角色-->
            <!--<Icon type="ios-arrow-down"></Icon>-->
            <!--</div>-->
            <!--<DropdownMenu slot="list">-->
            <!--<DropdownItem v-for="(item,index) in roleMap">{{item.name}}</DropdownItem>-->
            <!--</DropdownMenu>-->
            <!--</Dropdown>-->
          </Col>
          <Col span="4">所属案件</Col>
          <Col span="2">是否在办</Col>
          <Col span="3">操作</Col>
        </Row>
        <Row class="approval-list" v-for="(item,index) in list" :style="index%2==0?'background-color:#f8f8f9':''">
          <Col span="3" style="height: 100%;line-height:95px"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.name}}</span></Col>
          <Col span="2" style="height: 100%;line-height:95px"><span style="display:inline-block;line-height:1em;vertical-align: middle;">{{item.identityName||'未知'}}</span></Col>
          <Col span="2" style="height: 100%;line-height:95px"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.contactName||'未知'}}</span></Col>
          <Col span="2" style="height: 100%;line-height:95px"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.contactMobile||'未知'}}</span></Col>
          <Col span="4" style="height: 100%;line-height:95px"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.IDCardCode||'未知'}}</span></Col>
          <Col span="2" style="height: 100%;line-height:95px"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.roleName||'未知'}}</span></Col>
          <Col span="4" style="height: 100%;line-height:95px"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.projectName||'未知'}}</span></Col>
          <Col span="2" style="height: 100%;line-height:95px">
            <i-switch @on-change="changeState(item)" v-model="item.state" :disabled="item.projectName!=''" true-value="1" false-value="0"/>
          </Col>
          <Col span="3" style="text-align: center;line-height:95px">
            <Button
                type="success"
                :disabled="item.projectName!=''"
                style="border-radius: 18px;"
                @click="edit.name = item.name,
            edit.mobile = item.mobile,
            edit.role = item.role,
            edit.id = item.id,
            edit.IDCardCode = item.IDCardCode,
            edit.state = item.state,
            edit.projectName = item.projectName,
            edit.panel=true">
              编辑
            </Button>
            <Button
                type="error"
                :disabled="item.projectName!=''"
                style="border-radius: 18px;margin-left:10px"
                @click="deleteCustomer(item.id)"
            >
              删除
            </Button>
          </Col>
        </Row>
        <div style="padding: 20px;"></div>
        <Page
            :show-sizer="true"
            :show-total="true"
            @on-page-size-change="search.pageSize=$event;getList()"
            :total="search.total"
            :page-size="search.pageSize"
            :page-size-opts="[5,10,15]"
            show-elevator
            @on-change="search.page = $event;getList()"
        />
      </TabPane>
      <TabPane label="司法通讯录" name="contacts">
        <Row class="approval-list-tab">
          <Col span="3">名称</Col>
          <Col span="4">号码</Col>
          <Col span="3" v-if="$store.state.userInfo.groupName=='超级管理员'">操作</Col>
        </Row>
        <Row class="approval-list" v-for="(item,index) in contactsList" :style="index%2==0?'background-color:#f8f8f9':''">
          <Col span="3" style="height: 100%;line-height:95px"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.JudicialName}}</span></Col>
          <Col span="4" style="height: 100%;line-height:95px"><span style="display:inline-block;line-height:1em;vertical-align: middle;">{{item.JudicialPhone||'未知'}}</span></Col>
          <Col span="3" style="text-align: center;line-height:95px" v-if="$store.state.userInfo.groupName=='超级管理员'">
            <Button
                type="success"
                style="border-radius: 18px;"
                @click="contactsEdit={panel:true,name:item.JudicialName,tel:item.JudicialPhone,id:item.JudicialId,state:true}">
              编辑
            </Button>
            <Button
                type="error"
                style="border-radius: 18px;margin-left:10px"
                @click="deleteContacts(item.JudicialId)"
            >
              删除
            </Button>
          </Col>
        </Row>
        <div style="padding: 20px;"></div>
        <Page
            :show-sizer="true"
            :show-total="true"
            @on-page-size-change="contactsSearch.pageSize=$event;getList()"
            :total="contactsSearch.total"
            :page-size="contactsSearch.pageSize"
            :page-size-opts="[5,10,15]"
            show-elevator
            @on-change="contactsSearch.page = $event;getList()"
        />
      </TabPane>
      <TabPane label="律所通讯录" name="lawyer">
        <Row class="jurisdiction">
          <Col span="2">头像</Col>
          <Col span="4">姓名</Col>
          <Col span="4">电话号码</Col>
          <Col span="6">律所</Col>
          <Col span="4">权限组</Col>
          <Col span="3">申请时间</Col>
          <!--<Col span="3">全部成员</Col>-->
          <!--<Col span="3">操作</Col>-->
        </Row>
        <!--权限列表-->
        <Row class="jurisdiction-list" v-for="(item,index) in userList">
          <Col span="2">
            <p style="vertical-align: middle;">
              <Avatar v-if="item.icon" :src="item.icon" style="margin-right: 9px;"/>
              <Avatar v-else style="margin-right: 9px;">{{item.name[0]}}</Avatar>
            </p>
          </Col>
          <Col span="4"><p class="tips-middle">{{item.name}}</p></Col>
          <Col span="4"><p class="tips-middle">{{item.mobile}}&nbsp;</p></Col>
          <Col span="6"><p class="tips-middle">{{item.groupName}}&nbsp;</p></Col>
          <Col span="4"><p class="tips-middle">{{item.teamName}}&nbsp;</p></Col>
          <Col span="3"><p class="tips-middle">{{item.createDate}}</p></Col>
          <!--<Col span="3" v-if="item.state">正常</Col>-->
          <!--<Col span="3" v-else>禁用</Col>-->
          <!--<Col span="3" style="color: #00a2e9;"><span style="cursor: pointer" @click="editUserInfo(item)">编辑</span> | <span @click="deleteUser(item.id)" style="cursor: pointer">删除</span></Col>-->
        </Row>
        <Row>
          <Col span="24" style="margin-top:40px;">
            <Page
                :show-sizer="true"
                :show-total="true"
                @on-page-size-change="lawyerSearch.pageSize=$event;getUserList()"
                :total="lawyerSearch.total"
                :page-size="lawyerSearch.pageSize"
                :page-size-opts="[5,10,15]"
                show-elevator
                @on-change="lawyerSearch.page = $event;getUserList()"
            />
          </Col>
        </Row>
        <div style="padding: 20px;"></div>
      </TabPane>
    </Tabs>
    <!---->
    <Modal
        v-model="edit.panel"
        title="新增客户"
        width="700px"
        @on-ok="Boolean(edit.id)?saveCustomer():createCustomer()"
        ok-text="保存"
    >
      <Row type="flex" align="middle">
        <Col span="4" style="text-align: right">姓名：</Col>
        <Col span="7"><Input v-model="edit.name"></Input></Col>
        <Col span="4" style="text-align: right">电话号码：</Col>
        <Col span="7"><Input v-model="edit.mobile"></Input></Col>
      </Row>
      <div style="padding:10px"></div>
      <Row type="flex" align="middle">
        <Col span="4" style="text-align: right">身份证号：</Col>
        <Col span="7"><Input v-model="edit.IDCardCode"></Input></Col>
        <Col span="4" style="text-align: right">客户角色：</Col>
        <Col span="7">
          <Select v-model="edit.role" style="width:200px">
            <Option  v-for="(item,index) in roleMap" :value="item.id" :key="index">{{item.name}}</Option>
          </Select>
        </Col>
      </Row>
      <div style="padding:10px"></div>
      <Row type="flex" align="middle">
        <Col span="4" style="text-align: right">是否在办：</Col>
        <Col span="7">
          <i-switch true-value="1" false-value="0" v-model="edit.state"></i-switch>
        </Col>
      </Row>
    </Modal>
      <Modal
          v-model="contactsEdit.panel"
          title="新增司法通讯录"
          width="700px"
          @on-ok="saveContacts()"
          ok-text="保存"
      >
        <Row type="flex" align="middle">
          <Col span="4" style="text-align: right">名称：</Col>
          <Col span="7"><Input v-model="contactsEdit.name"></Input></Col>
          <Col span="4" style="text-align: right">号码：</Col>
          <Col span="7"><Input v-model="contactsEdit.tel"></Input></Col>
        </Row>
      </Modal>
    <div style="padding: 20px;"></div>
  </div>
  </div>
</template>

<script>
  export default {
    name: "customer",//客户名录
    data:function(){
      return{
        list:[],
        edit:{
          panel:false,
          name:'',
          id:'',
          mobile:'',
          IDCardCode:'',
          role:'',
          state:'',
        },
        contactsList:[],
        contactsEdit:{
          panel:false,
          name:'',
          id:'',
          tel:'',
        },
        contactsLit:[
          {name:'',tel:'',},
        ],
        roleMap:[],
        search:{
          pageSize: 15,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          text:'',//搜索文字
        },
        contactsSearch:{
          pageSize: 15,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          text:'',//搜索文字
        },
        lawyerSearch:{
          pageSize: 15,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          text:'',//搜索文字
        },
        userList:[],
      }
    },
    methods: {

      //司法通讯录
      getContactsList:function(){
        var _this = this
        _this.contactsList = []
        _this.send({
          headers:'S/JudicialList',
          data:{
            page : _this.contactsSearch.page,
            pageSize : _this.contactsSearch.pageSize,
            key : _this.search.text,
            JudicialName:_this.contactsEdit.name,
            JudicialPhone:_this.contactsEdit.tel,
          },
          success:function (res) {
            _this.contactsList = res.List
            _this.contactsSearch.total = res.Count
          }
        })
      },
      saveContacts:function(){
        var _this = this
        _this.send({
          headers:'S/SetJudicial',
          data:{
            JudicialName:_this.contactsEdit.name,
            JudicialPhone:_this.contactsEdit.tel,
            JudicialId:_this.contactsEdit.id,
          },
          success:function (res) {
            _this.getContactsList()
          }
        })
      },
      deleteContacts:function(id){
        var _this = this
        _this.send({
          headers:'S/DelJudicial',
          data:{
            JudicialId:id,
          },
          confirm:true,
          success:function (res) {
            _this.getContactsList()
          }
        })
      },
      //获取用户列表
      getUserList:function () {
        var _this = this
        _this.userList = []
        _this.send({
          headers:'U/UserList',
          data:{
            page : _this.lawyerSearch.page,
            pageSize : _this.lawyerSearch.pageSize,
            key : _this.search.text,
          },
          success:function (res) {
            var userArr = []
            _this.userList = []
            var i=0
            for(var index in res.List){
              userArr[i] = {}
              userArr[i].id = res.List[index].UserId
              userArr[i].icon = res.List[index].Icon
              userArr[i].name = res.List[index].UserName
              userArr[i].mobile = res.List[index].UserMobile
              userArr[i].state = Boolean(res.List[index].UserAble)
              userArr[i].groupId = res.List[index].PurviewId
              userArr[i].groupName = res.List[index].GroupName
              userArr[i].teamName = res.List[index].PurviewName
              userArr[i].teamId = res.List[index].GroupId
              userArr[i].createDate = res.List[index].RegisterTime
              userArr[i].recommender = res.List[index].WageFid
              i++
            }
            _this.lawyerSearch.total=res.Count
            _this.userList = userArr
          }
        })
      },
      getLitigationStatusList:function(){
        var _this = this
        _this.send({
          headers:'R/LitigationStatus',
          success:function (res) {
            _this.roleMap = []
            for(var index in res){
              _this.roleMap.push({
                name:res[index].LitigationStatusName,
                id:res[index].LitigationStatusId
              })
            }
            _this.getList()
          }
        })
      },
      changeState:function(item){
        var _this = this
        _this.send({
          headers:'R/EditCustomer ',
          data:{
            LitigantId:item.id,
            LitigantName:item.name,
            LitigantMobile:item.mobile,
            LitigantIdCard:item.IDCardCode,
            LitigationStatusId:item.role,
            LitigantAble:item.state,
          },
          success:function (res) {
            _this.getList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'客户信息保存成功！'
            })
          }
        })
      },
      saveCustomer:function(){
        var _this = this
        _this.send({
          headers:'R/EditCustomer ',
          data:{
            LitigantId:_this.edit.id,
            LitigantName:_this.edit.name,
            LitigantMobile:_this.edit.mobile,
            LitigantIdCard:_this.edit.IDCardCode,
            LitigationStatusId:_this.edit.role,
            LitigantAble:_this.edit.state,
          },
          success:function (res) {
            _this.getList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'客户信息保存成功！'
            })
          }
        })
      },
      deleteCustomer:function(id){
        var _this = this
        _this.send({
          headers:'R/DeleteCustomer ',
          confirm:true,
          data:{
            LitigantId:id,
          },
          success:function (res) {
            _this.getList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'客户信息删除成功！'
            })
          }
        })
      },
      createCustomer:function(){
        var _this = this
        _this.send({
          headers:'R/AddCustomer',
          data:{
            LitigantName:_this.edit.name,
            LitigantMobile:_this.edit.mobile,
            LitigantIdCard:_this.edit.IDCardCode,
            LitigationStatusId:_this.edit.role,
            LitigantAble:_this.edit.state,
          },
          success:function (res) {
            _this.getList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'客户信息保存成功！'
            })
          }
        })
      },
      getList:function () {
        var _this = this
        _this.list = []
        _this.send({
          headers:'R/ShowCustomer',
          data:{
            page : _this.search.page,
            pageSize : _this.search.pageSize,
            key : _this.search.text,
          },
          success:function (res) {
            var i = 0
            for(var index in res.List){
              _this.list.push({
                id:res.List[index].LitigantId,
                name:res.List[index].LitigantName,
                contactName:res.List[index].CaseLinkman,
                contactMobile:res.List[index].CaseLinkmanTel,
                IDCardCode:res.List[index].LitigantIdCard,
                state:typeof res.List[index].LitigantAble=='number'?res.List[index].LitigantAble.toString():'',
                role:res.List[index].LitigationStatusId,
                roleName:res.List[index].LitigationStatusName,
                identityName:res.List[index].LitigantTypeTitle,
                projectName:res.List[index].CaseTitle,
              })
              i++
            }
            _this.search.total = res.count
          }
        })
      }
    },
    mounted:function(){
      this.getUserList()
      this.getContactsList()
      this.getLitigationStatusList()
    },
  }
</script>
